export default "__VITE_ASSET__61ce8453__"